import React from 'react';

const LandingNavbar = ({ onLoginClick, onAboutClick }) => {
  return (
    <nav className="bg-white/95 backdrop-blur-sm shadow-sm border-b sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">AI</span>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-900">Assist</h1>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <button
              onClick={onAboutClick}
              className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
            >
              About
            </button>
            <button
              onClick={onLoginClick}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;

